import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useChangeBaseRole = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [changeBaseRoleLoading, setChangeBaseRoleLoading] = useState(false);

  const changeBaseRoleRequest = (
    payload,
    getRoleList,
    setIsChangeBaseRoleModalOpen,
  ) => {
    setChangeBaseRoleLoading(true);
    axiosClient
      .put(`SettingAccount/User/ChangeBaseRole`, payload)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          getRoleList();
          setIsChangeBaseRoleModalOpen(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setChangeBaseRoleLoading(false));
  };
  return { changeBaseRoleRequest, changeBaseRoleLoading };
};

export default useChangeBaseRole;
